export default __webpack_public_path__ + "static/media/Heart@3x.c9866c57.png";